export enum FormType {
  PACKAGE = 'PACKAGE',
  SIDE_EFFECT = 'SIDE_EFFECT',
  ACTIVE_INGREDIENT = 'ACTIVE_INGREDIENT',
  SUPPLIER = 'SUPPLIER',
  MANUFACTURER = 'MANUFACTURER',
  MEDICINE = 'MEDICINE',
  // Add more form types here as needed
}

export interface GenericFormModalProps {
  isOpen: boolean;
  toggle: () => void;
  formType: FormType;
  onSuccess: (data: any) => void;
  entityId?: string; // e.g., packageSizeId, sideEffectId
  size?: 'lg' | 'md' | 'sm';
}
